<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row">
                <div class="col-4">
                  <input
                    v-model="table.search"
                    class="form-control rounded-pill text-center"
                    type="text"
                    placeholder="Search Material Type"
                    @keyup="filter"
                  />
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div class="table-responsive" style="height: 500px">
              <table v-if="!table.onLoad" class="table">
                <thead class="table-primary">
                  <tr>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Customer ID
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Customer Name
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Contact Person
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Email
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Phone
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Address
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      City
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Country
                    </th>
                    <th
                      class="text-uppercase text-dark text-xxs font-weight-bolder text-center w-1"
                    >
                      Created At
                    </th>
                  </tr>
                </thead>
                <tbody v-if="table.data.length > 0">
                  <tr v-for="type in table.data" :key="type.id">
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 6cm"
                    >
                      <div>{{ type.customer_id }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.customer_name }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.contact_person }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.email }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.phone }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.address }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.city }}</div>
                    </td>
                    <td
                      class="text-sm py-3 px-4 value-table-wrapped"
                      style="max-width: 10cm"
                    >
                      <div>{{ type.country }}</div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colspan="3">No Data</td>
                  </tr>
                </tbody>
              </table>

              <SkeletonLoading
                v-else
                class="px-4 pt-5"
                :shapes="[
                  { type: 'line', width: '100%', height: '20px' },
                  { type: 'line', width: '80%', height: '20px' },
                  { type: 'line', width: '60%', height: '20px' },
                ]"
              />
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination
                  v-model="table.page.current_pages"
                  :page-count="table.page.total_pages"
                  size="sm"
                  @click="changePage()"
                />
              </span>
              <span class="float-end">
                {{
                  (table.page.current_pages - 1) * table.page.per_pages +
                  table.data.length
                }}
                of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import moment from "moment";
import api from "@/helpers/api";
import glAccountService from "@/services/generalMasterData/glAccountService"; // Sesuaikan dengan path service

export default {
  components: {
    BasePagination,
    SkeletonLoading,
  },
  data() {
    return {
      loadTimeout: null,
      table: {
        onLoad: false,
        search: this.$route.query.code || "", // Mengambil nilai pencarian dari query
        total: 0,
        data: [
            {
                "customer_id": "C001",
                "customer_name": "PT. Sejahtera Abadi",
                "contact_person": "Budi Hartono",
                "email": "budi@sejahteraabadi.co.id",
                "phone": "+62 812-1234-5678",
                "address": "Jl. Merdeka No. 10, Jakarta",
                "city": "Jakarta",
                "country": "Indonesia"
            },
            {
                "customer_id": "C002",
                "customer_name": "CV. Makmur Sentosa",
                "contact_person": "Siti Aisyah",
                "email": "siti@makmursentosa.com",
                "phone": "+62 813-8765-4321",
                "address": "Jl. Sudirman No. 15, Surabaya",
                "city": "Surabaya",
                "country": "Indonesia"
            },
            {
                "customer_id": "C003",
                "customer_name": "PT. Nusantara Jaya",
                "contact_person": "Agus Widodo",
                "email": "agus@nusantarajaya.co.id",
                "phone": "+62 811-2222-3333",
                "address": "Jl. Diponegoro No. 8, Bandung",
                "city": "Bandung",
                "country": "Indonesia"
            },
            {
                "customer_id": "C004",
                "customer_name": "UD. Berkah Mandiri",
                "contact_person": "Dewi Lestari",
                "email": "dewi@berkahmandiri.com",
                "phone": "+62 812-3344-5566",
                "address": "Jl. Ahmad Yani No. 14, Yogyakarta",
                "city": "Yogyakarta",
                "country": "Indonesia"
            },
            {
                "customer_id": "C005",
                "customer_name": "PT. Sentosa Perkasa",
                "contact_person": "Hendra Saputra",
                "email": "hendra@sentosaperkasa.com",
                "phone": "+62 817-5678-9012",
                "address": "Jl. Pahlawan No. 20, Medan",
                "city": "Medan",
                "country": "Indonesia"
            },
            {
                "customer_id": "C006",
                "customer_name": "PT. Cahaya Gemilang",
                "contact_person": "Rina Kusuma",
                "email": "rina@cahayagemilang.com",
                "phone": "+62 819-2222-3333",
                "address": "Jl. Gajah Mada No. 32, Semarang",
                "city": "Semarang",
                "country": "Indonesia"
            },
            {
                "customer_id": "C007",
                "customer_name": "CV. Indo Makmur",
                "contact_person": "Adi Prasetyo",
                "email": "adi@indomakmur.id",
                "phone": "+62 815-6789-0123",
                "address": "Jl. Pemuda No. 20, Palembang",
                "city": "Palembang",
                "country": "Indonesia"
            },
            {
                "customer_id": "C008",
                "customer_name": "PT. Sukses Bersama",
                "contact_person": "Lia Rahmawati",
                "email": "lia@suksesbersama.com",
                "phone": "+62 818-9999-8888",
                "address": "Jl. Jenderal Sudirman No. 99, Makassar",
                "city": "Makassar",
                "country": "Indonesia"
            },
            {
                "customer_id": "C009",
                "customer_name": "UD. Maju Lancar",
                "contact_person": "Teguh Wibowo",
                "email": "teguh@majulancar.co.id",
                "phone": "+62 816-4444-7777",
                "address": "Jl. Kartini No. 11, Malang",
                "city": "Malang",
                "country": "Indonesia"
            },
            {
                "customer_id": "C010",
                "customer_name": "PT. Global Sentosa",
                "contact_person": "Dian Kurniawan",
                "email": "dian@globalsentosa.com",
                "phone": "+62 812-1111-2222",
                "address": "Jl. Sudirman No. 5, Pekanbaru",
                "city": "Pekanbaru",
                "country": "Indonesia"
            },
            {
                "customer_id": "C011",
                "customer_name": "PT. Indo Jaya Perkasa",
                "contact_person": "Rizky Ananda",
                "email": "rizky@indojayaperkasa.com",
                "phone": "+62 819-7777-6666",
                "address": "Jl. Diponegoro No. 78, Denpasar",
                "city": "Denpasar",
                "country": "Indonesia"
            },
            {
                "customer_id": "C012",
                "customer_name": "CV. Amanah Sejahtera",
                "contact_person": "Siti Aminah",
                "email": "siti@amanahsejahtera.com",
                "phone": "+62 818-5555-4444",
                "address": "Jl. Veteran No. 12, Balikpapan",
                "city": "Balikpapan",
                "country": "Indonesia"
            },
            {
                "customer_id": "C013",
                "customer_name": "PT. Prima Jaya",
                "contact_person": "Aditya Nugroho",
                "email": "aditya@primajaya.co.id",
                "phone": "+62 811-6666-5555",
                "address": "Jl. Gatot Subroto No. 21, Manado",
                "city": "Manado",
                "country": "Indonesia"
            },
            {
                "customer_id": "C014",
                "customer_name": "UD. Harmoni",
                "contact_person": "Teguh Santoso",
                "email": "teguh@udharmoni.com",
                "phone": "+62 817-3333-2222",
                "address": "Jl. Thamrin No. 19, Samarinda",
                "city": "Samarinda",
                "country": "Indonesia"
            },
            {
                "customer_id": "C015",
                "customer_name": "PT. Berkah Mandiri",
                "contact_person": "Yusuf Rahman",
                "email": "yusuf@berkahmandiri.com",
                "phone": "+62 813-8888-7777",
                "address": "Jl. Sudirman No. 55, Banda Aceh",
                "city": "Banda Aceh",
                "country": "Indonesia"
            },
            {
                "customer_id": "C016",
                "customer_name": "CV. Mulia Sejahtera",
                "contact_person": "Nina Sari",
                "email": "nina@muliaserahtera.com",
                "phone": "+62 816-2222-1111",
                "address": "Jl. Pasar Baru No. 8, Pontianak",
                "city": "Pontianak",
                "country": "Indonesia"
            },
            {
                "customer_id": "C017",
                "customer_name": "PT. Mega Sentosa",
                "contact_person": "Ahmad Fauzi",
                "email": "ahmad@megasentosa.com",
                "phone": "+62 819-4444-3333",
                "address": "Jl. Dipatiukur No. 30, Palu",
                "city": "Palu",
                "country": "Indonesia"
            },
            {
                "customer_id": "C018",
                "customer_name": "UD. Karya Utama",
                "contact_person": "Lina Pramesti",
                "email": "lina@karyautama.co.id",
                "phone": "+62 815-6666-9999",
                "address": "Jl. Asia Afrika No. 77, Kendari",
                "city": "Kendari",
                "country": "Indonesia"
            }
        ]
,
        page: {
          current_pages: 1,
          per_pages: 100, // Tambahkan sesuai kebutuhan
        },
      },
    };
  },
  watch: {
    "table.page.current_pages": {
      handler() {
        this.get();
      },
    },
  },
  mounted() {
    // this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;

      try {
        const response = await api(
          this,
          glAccountService.list(this.table.page.current_pages, {
            code: this.table.search,
          }),
          false
        );

        this.table.data = response.data.data;
        this.table.total = response.data.total_items;
        this.table.page = response.data;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        this.updateQuery(); // Memperbarui URL
        this.get();
      }, 300);
    },
    updateQuery() {
      this.$router.push({ query: { code: this.table.search } });
    },
    changePage() {
      this.get();
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY, HH:mm");
    },
  },
};
</script>

<style scoped>
/* Tambahkan styling sesuai kebutuhan */
</style>
